import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import Modal from '@welldev-group/rcl-modal';
import Link from '@welldev-group/rcl-link';

const SubscriptionFeatureDetailsModal = ({
  isVisible,
  greetingText,
  successText,
  upgradedFeatureDetails,
  redirectTo,
  onOutsideClick,
}) => {
  const featureIncreased =
    upgradedFeatureDetails?.moreWorkspaces > 0 ||
    upgradedFeatureDetails?.moreChannels > 0 ||
    upgradedFeatureDetails?.customDomainSupported ||
    upgradedFeatureDetails?.morePhoneSupport;
  const upgradedFeatureListElement = (
    <div className="subscription-feature-details-modal__body-feature-details">
      <div className="subscription-feature-details-modal__body-feature-details-title">
        {I18n.t(
          'components.subscription.subscription_feature_details_modal.upgrade.body.title',
        )}
      </div>
      <ul className="subscription-feature-details-modal__body-feature-details-list">
        {upgradedFeatureDetails?.moreWorkspaces > 0 ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item">
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.upgrade.body.workspace',
              {
                count: upgradedFeatureDetails?.moreWorkspaces,
              },
            )}
          </li>
        ) : null}
        {upgradedFeatureDetails?.moreChannels > 0 ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item">
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.upgrade.body.channel',
              {
                count: upgradedFeatureDetails?.moreChannels,
              },
            )}
          </li>
        ) : null}
        {upgradedFeatureDetails?.morePhoneSupport ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item">
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.upgrade.body.phone_support',
              {
                phoneSupportQuantity: upgradedFeatureDetails.morePhoneSupport,
              },
            )}
          </li>
        ) : null}
        {upgradedFeatureDetails?.customDomainSupported ? (
          <li className="subscription-feature-details-modal__body-feature-details-list-item">
            {I18n.t(
              'components.subscription.subscription_feature_details_modal.upgrade.body.custom_domain',
            )}
          </li>
        ) : null}
      </ul>
    </div>
  );

  return (
    <Modal
      className="subscription-feature-details-modal"
      isVisible={isVisible}
      onOutsideClick={onOutsideClick}
    >
      <Modal.Content
        className="subscription-feature-details-modal__body"
        align="center"
      >
        <Icon
          className="subscription-feature-details-modal__body-success-icon"
          name="check"
          showBGColor={true}
          color="success"
        />
        <div className="subscription-feature-details-modal__body-greeting-text">
          {greetingText}
        </div>
        <div className="subscription-feature-details-modal__body-success-text">
          {successText}
          {featureIncreased ? (
            <>
              {' '}
              {I18n.t(
                'components.subscription.subscription_feature_details_modal.upgrade.success_text.more_features_text',
              )}
            </>
          ) : null}
        </div>
        {featureIncreased ? upgradedFeatureListElement : null}
      </Modal.Content>
      <Modal.Footer className="subscription-feature-details-modal__footer">
        <Link type="button" size="small" modifier="primary" href={redirectTo}>
          {I18n.t(
            'components.subscription.subscription_feature_details_modal.upgrade.footer.link.close',
          )}
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

SubscriptionFeatureDetailsModal.defaultProps = {
  isVisible: false,
  greetingText: '',
  successText: '',
  upgradedFeatureDetails: null,
  redirectTo: '',
  onOutsideClick: () => {},
};

SubscriptionFeatureDetailsModal.propTypes = {
  isVisible: PropTypes.bool,
  greetingText: PropTypes.string,
  successText: PropTypes.string,
  upgradedFeatureDetails: {
    moreWorkspaces: PropTypes.number,
    moreChannels: PropTypes.number,
    customDomainSupported: PropTypes.string,
    morePhoneSupport: PropTypes.bool,
  },
  redirectTo: PropTypes.string,
  onOutsideClick: PropTypes.func,
};

export default SubscriptionFeatureDetailsModal;
